import { render, staticRenderFns } from "./AvatarMenuCompanies.vue?vue&type=template&id=d2c96dc2"
import script from "./AvatarMenuCompanies.vue?vue&type=script&lang=ts"
export * from "./AvatarMenuCompanies.vue?vue&type=script&lang=ts"
import style0 from "./AvatarMenuCompanies.vue?vue&type=style&index=0&id=d2c96dc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSubmoduleIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/SubmoduleIcon.vue').default,IconsIdentidadIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/IdentidadIcon.vue').default})
